import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type AuthForgetPasswordServiceInput = {
  payload: {
    email?: string
    company?: string
  }
}

export const authForgetPasswordService = async ({
  payload,
}: AuthForgetPasswordServiceInput): Promise<ResponseAPI> => {
  const response = await api.post('recuperarsenha', payload.email, {
    headers: {
      empresa: payload.company,
    },
  })

  return response.data
}
